import { render, staticRenderFns } from "./subject-post-item.vue?vue&type=template&id=a503d2d0&scoped=true&"
import script from "./subject-post-item.vue?vue&type=script&lang=js&"
export * from "./subject-post-item.vue?vue&type=script&lang=js&"
import style0 from "./subject-post-item.vue?vue&type=style&index=0&id=a503d2d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a503d2d0",
  null
  
)

export default component.exports